<script setup>
    import { ChevronUpDownIcon } from '@heroicons/vue/20/solid';
    import { computed } from 'vue';

    const props = defineProps({
        modelValue: {
            type: [String, Number],
            default: ''
        },
        options: {
            type: Array,
            required: true
        },
        disabled: {
            type: Boolean,
            default: false
        }
    })

    const emit = defineEmits(['update:modelValue'])

    const localValue = computed({
        get: () => props.modelValue,
        set: (value) => emit('update:modelValue', value)
    })
</script>

<template>
    <div class="relative">
        <select
            class="appearance-none bg-transparent bg-none cursor-pointer text-center border-0 text-sm font-semibold p-0 [-webkit-appearance:none] [-moz-appearance:none] w-full text-gray-700 focus:ring-0 focus:border-0 background-image-none pr-3 select-none rounded-sm"
            :class="[
                props.disabled ? 'pointer-events-none' : 'hover:bg-lifeworx-blue-600/20'
            ]"
            :disabled="props.disabled"
            v-model="localValue"
        >
            <option v-for="option in props.options" :key="option.value" :value="option.value">
            {{ option.name }}
            </option>
        </select>
        <div class="flex items-center bg-transparent pointer-events-none absolute inset-y-0 right-0">
            <ChevronUpDownIcon class="h-4 w-4 stroke-2 inline-flex"/>
        </div>
    </div>
</template>
